import React from 'react';
import { Button, Col, Input, Modal, ModalFooter, ModalBody, ModalHeader, Row } from 'reactstrap';
import { parseTelephone } from '../../utils';
import PhoneTypes from './LookupDropDown';
import ControlledNumericInput from './ControlledNumericInput';

class PhoneInputModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            extensionIsValid: true,
            phoneTypeId: 22
        }
    }

    handleOnTypeChange = (e) => {
        this.props.onPhoneTypeChange(e.target.value);
    }

    handleOnNumberChange = (e) => {
        const newPhone = this.props.personPhone;
        Object.assign(newPhone.phone, parseTelephone(e.target.value));
        newPhone.isValid = e.target.validity.valid;
        this.setState({ isValid: newPhone.isValid })
        this.props.onNumberChange(newPhone);
    }

    handleOnIsPrimaryChange = (e) => {
        this.props.handleOnIsPrimaryPhoneChanged(e.target.checked);
    }

    handleOnExtensionChange = (name, value) => {
        const newPhone = this.props.personPhone;
        newPhone.extension = value;
        this.props.onNumberChange(newPhone);
    }

    handleExtensionChanged = (canSave) => {
        canSave ? this.setState({ extensionIsValid: true }) : this.setState({ extensionIsValid: false })
    }

    handleSave = () => {
        this.props.onSave();
        this.props.onToggle();
    }

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.props.onToggle}
                size='lg'
            >
                <ModalHeader toggle={this.props.toggle}>Add / Edit Phone Number</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <PhoneTypes
                                label='Type'
                                name='phoneTypeId'
                                onChange={this.handleOnTypeChange}
                                lookups={this.props.phoneTypes}
                                value={this.props.personPhone.phoneTypeId}
                                inline={true}
                            />
                        </Col>
                        <Col>
                            <Input type="tel" id="phone" name="phone"
                                placeholder="123-456-7890"
                                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                                required
                                value={this.props.personPhone.phone.formattedNumber}
                                onChange={this.handleOnNumberChange}
                                maxLength={12}
                                valid={this.props.personPhone.isValid === undefined ? this.props.personPhone.phone.formattedNumber : this.props.personPhone.isValid}
                                invalid={!(this.props.personPhone.isValid === undefined ? this.props.personPhone.phone.formattedNumber : this.props.personPhone.isValid)}
                            />
                        </Col>
                        <Col>
                            <ControlledNumericInput
                                name='extension'
                                maxLengthToUse={7}
                                min='0'
                                max='9999999'
                                numberValue={this.props.personPhone.extension || ''}
                                disableSave={this.handleExtensionChanged}
                                setField={this.handleOnExtensionChange}
                                isValid={this.state.extensionIsValid}
                            />
                        </Col>
                        <Col className='d-flex align-items-center'>
                            <Input
                                id='isPrimary'
                                name='IsPrimary'
                                type='checkbox'
                                label="Primary"
                                checked={this.props.personPhone.isPrimary}
                                onChange={this.handleOnIsPrimaryChange}
                            />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button disabled={this.state.isValid === false || !this.props.personPhone.phone.formattedNumber || !this.state.extensionIsValid} color="primary" onClick={this.handleSave}>Save</Button>{' '}
                    <Button color="secondary" onClick={this.props.onToggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default PhoneInputModal